import { useCallback, useEffect, useState } from "react";

/** Carrega uma lista do servidor ao montar, com estado de carregamento, falha e nova tentativa. */
export function useListaRemota<T>(buscar: () => Promise<T[]>, nome: string) {
  const [itens, setItens] = useState<T[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [falhou, setFalhou] = useState(false);

  const recarregar = useCallback(async () => {
    setCarregando(true);
    setFalhou(false);
    try {
      setItens(await buscar());
    } catch (error) {
      console.error(`[PreInscricao] falha ao carregar ${nome}`, error);
      setFalhou(true);
    } finally {
      setCarregando(false);
    }
  }, [buscar, nome]);

  useEffect(() => {
    recarregar();
  }, [recarregar]);

  return { itens, carregando, falhou, recarregar };
}
